'use client';

import { motion, useScroll, useSpring } from 'framer-motion';

export default function ScrollUI() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 200, damping: 30, restDelta: 0.001 });

    return (
        <motion.div
            style={{ scaleX, transformOrigin: 'left' }}
            className="fixed top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-indigo-500 via-blue-500 to-sky-400 z-40 pointer-events-none"
        />
    );
}
